import { truncateData } from '../../services';
import StyledTooltip from '../tooltip';
import { HighlightedTextInterface } from './high-lighted-text.props';

function HighlightedText({ text, highlightWords }: HighlightedTextInterface) {
  const truncatedText = truncateData(text, 100);

  // const parts = truncatedText.split(new RegExp(`(${highlightWords.join('|')})`, 'gi'));
  const regexPattern = new RegExp(`\\b(${highlightWords.join('|')})\\b`, 'gi');
  const parts = truncatedText.split(regexPattern);

  return (
    <>
      {parts.map((part) => {
        const isHighlighted = highlightWords.some(
          (word) => part.toLowerCase() === word.toLowerCase(),
        );
        return isHighlighted ? (
          <StyledTooltip title={text} key={`${part}_highlight`}>
            <span style={{ color: 'red' }}>{part}</span>
          </StyledTooltip>
        ) : (
          <StyledTooltip title={text} key={`${part}_highlight_tooltip`}>
            <span
              style={{
                overflowWrap: 'anywhere',
                wordBreak: 'break-all',
              }}
            >
              {part}
            </span>
          </StyledTooltip>
        );
      })}
    </>
  );
}

export default HighlightedText;
